import { LOGGER_SERVICE_AUTH as n } from "@waitroom/models";
import U from "deepmerge";
import { logger as u } from "./config.es.js";
import { redactState as a } from "./log.es.js";
import { authService as S } from "./service.es.js";
import { create as d } from "./external/zustand/esm/react.es.js";
const m = {
  ...S.getAnonymous(),
  status: void 0
}, s = d()(() => m), I = (t) => {
  var e;
  (e = u) == null || e.logService(n, 5, "Set auth state", a(t)), s.setState(t || S.getAnonymous(), !0);
}, A = (t) => {
  var e;
  (e = u) == null || e.logService(n, 5, "Update auth state", a(t)), s.setState((r) => ({ ...r, ...t }));
}, C = (t) => {
  var e;
  (e = u) == null || e.logService(n, 5, "Set current user"), s.setState((r) => ({
    ...r,
    currentUser: t,
    userId: t == null ? void 0 : t.id
  }));
}, E = (t) => {
  var e;
  (e = u) == null || e.logService(n, 5, "Update current user"), t && s.setState((r) => {
    if (!r.currentUser) return r;
    const o = U(r.currentUser, t);
    return {
      ...r,
      currentUser: o,
      userId: t.id || r.userId
    };
  });
}, D = (t) => {
  var e;
  (e = u) == null || e.logService(n, 5, "Update subscription plan", t), s.setState((r) => r.currentUser ? {
    ...r,
    currentUser: {
      ...r.currentUser,
      subscriptionPlan: t
    }
  } : r);
}, G = (t) => {
  t && s.setState((e) => {
    if (!e.currentUser) return e;
    const r = e.currentUser.lobbies || [];
    let o = !1;
    const c = r.map((i) => i.lobbyID === t.lobbyID ? (o = !0, t) : i);
    return o || c.push(t), {
      ...e,
      currentUser: {
        ...e.currentUser,
        lobbies: c
      }
    };
  });
};
export {
  m as authInitialState,
  I as setAuthState,
  C as setCurrentUser,
  D as setSubscriptionPlan,
  A as updateAuthState,
  E as updateCurrentUser,
  G as upsertCurrentUserLobby,
  s as useAuthStore
};
